module.exports = __webpack_public_path__ + "media/images/federalchildtaxcredit-3f4ccb43a757c1843a80b66566a2207e.png";